export default {"src":"/uk/_next/static/media/bullet-checkmark.0e5fb742.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};